import useSWR from "swr";
import api from "../Services/api";
import { useState, useEffect } from "react";

export function useFetch(url, tag) {
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const api_url = url
    ? `https://nc8.olharfixo.com.br/Vehicles/api/v3/${url}`
    : null;

  const key = tag ? [tag, api_url] : api_url;

  const swr = useSWR(
    key,
    async (_key, realUrl = api_url) => {
      if (!realUrl) return null;
  
      // 🧩 bloqueia requisições duplicadas simultâneas
      if (loading) return null;
      setLoading(true);
  
      try {
        const response = await api.get(realUrl);
        if (!response?.data) {
          setErrorMessage("⚠️ Nenhum dado retornado do servidor.");
          return null;
        }
        setErrorMessage(null);
        return response.data;
      } catch (err) {
        console.error("Erro ao buscar dados:", err);
        setErrorMessage("❌ Erro ao buscar dados. Tente novamente.");
        return null;
      } finally {
        setLoading(false);
      }
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
      refreshInterval: 0,
      dedupingInterval: 10000, // 👈 impede SWR de refazer chamada igual por 10s
    }
  );
  

  // Se o URL mudar, limpar erro e loading antigo
  useEffect(() => {
    setErrorMessage(null);
    setLoading(false);
  }, [url]);

  return {
    data: swr.data ?? null,
    error: swr.error ?? null,
    loading, // 👈 indica se está carregando
    errorMessage, // 👈 texto de erro para o HTML
    isDisabled: !url,
    mutate: swr.mutate,
  };
}
